export async function jobs() {
    const jobs = document.querySelectorAll('.job_applications');

    if (jobs) {
        const { initJobs } = await import(/* webpackMode: "lazy" */ './jobs.async');

        initJobs();
    }
}
